




























import Vue from 'vue'
import { Order } from '../models';
export default Vue.extend({
  computed: {
    order(): Order {
      return this.$store.state.ordersList[0] || {};
    }
  }
})
